import React from "react"
import tw from "twin.macro"
import { ArrowRight, ArrowLeft } from "react-feather"
import styled from "@emotion/styled"
import { Link } from "gatsby"

interface Props {
  totalPages: number

  createURL?: Function
  currentPage?: number
  onPageChange?: (page: number) => void
}

export const Pagination: React.FC<Props> = ({
  totalPages,
  currentPage,
  onPageChange,
  createURL,
}) => {
  const handleLeftClick = () => {
    if (currentPage === 1) return

    onPageChange(--currentPage)
  }

  const handleRightClick = () => {
    if (currentPage === totalPages) return

    onPageChange(++currentPage)
  }

  return (
    <Styles.Wrapper>
      <Styles.Navigation
        onClick={handleLeftClick}
        disabled={currentPage === 1}
      >
        <ArrowLeft />
        <span>Previous</span>
      </Styles.Navigation>
      {new Array(totalPages).fill(null).map((_, index) => {
        const pageNumber = index + 1
        return (
          <Link key={pageNumber} to={createURL(pageNumber)}>
            <Styles.Page
              onClick={() => onPageChange(pageNumber)}
              active={pageNumber === currentPage}
            >
              {pageNumber}
            </Styles.Page>
          </Link>
        )
      })}
      <Styles.Navigation
        onClick={handleRightClick}
        disabled={currentPage === totalPages}
      >
        <span>Next</span>
        <ArrowRight />
      </Styles.Navigation>
    </Styles.Wrapper>
  )
}

const Styles = {
  Wrapper: tw.ul`flex`,
  Navigation: styled.li<{ disabled?: boolean }>`
    ${tw`flex items-center justify-center cursor-pointer font-semibold mx-1 px-3 py-2 bg-white rounded-lg hover:bg-gray-700 hover:text-gray-200`}

    ${({ disabled }) =>
      disabled &&
      tw`cursor-not-allowed text-gray-600 hover:text-gray-600 bg-gray-100 hover:bg-gray-100`}

    & > *:not(:last-child) {
      ${tw`mr-2`}
    }

    svg {
      ${tw`w-4`}
    }
  `,
  Page: styled.li<{ active?: boolean }>`
    ${tw`cursor-pointer mx-1 px-4 py-2 font-semibold bg-white hover:bg-gray-700 hover:text-gray-200 rounded-lg`}

    ${({ active }) => active && tw`bg-gray-700 text-gray-200`}
  `,
}
